module.exports = __webpack_public_path__ + "static/img/IMG_20170905_183218.ee0bf7c6.jpg";